/**
 * Generato automaticamente.
 * OpenAPI
 */
import { useQuery } from 'react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from 'react-query';
import { apiClientRequest } from '../../../client/apiClient.ts';
import type { ErrorType } from '../../../client/apiClient.ts';
import type { GetPlaceholdersSalvaInTabellaParams } from '../schemas/getPlaceholdersSalvaInTabellaParams.ts';
import type { PlaceholderDto } from '../schemas/placeholderDto.ts';
import type { WsProblema } from '../schemas/wsProblema.ts';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P,
) => any
  ? P
  : never;

/**
 * Ottiene la lista dei placeholder per tipo sezione, in ordine ascedente rispetto alla label
 * @summary Lista placeholder
 */
export const getPlaceholdersSalvaInTabella = (
  params: GetPlaceholdersSalvaInTabellaParams,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<PlaceholderDto[]>(
    {
      url: `/framework-cfg-domande/placeholders-salva-in-tabella`,
      method: 'get',
      params,
      signal,
    },
    options,
  );
};

export const getGetPlaceholdersSalvaInTabellaQueryKey = (
  params: GetPlaceholdersSalvaInTabellaParams,
) =>
  [
    `/framework-cfg-domande/placeholders-salva-in-tabella`,
    ...(params ? [params] : []),
  ] as const;

export const getGetPlaceholdersSalvaInTabellaQueryOptions = <
  TData = Awaited<ReturnType<typeof getPlaceholdersSalvaInTabella>>,
  TError = ErrorType<WsProblema>,
>(
  params: GetPlaceholdersSalvaInTabellaParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPlaceholdersSalvaInTabella>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getPlaceholdersSalvaInTabella>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPlaceholdersSalvaInTabellaQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPlaceholdersSalvaInTabella>>
  > = ({ signal }) =>
    getPlaceholdersSalvaInTabella(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions };
};

export type GetPlaceholdersSalvaInTabellaQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPlaceholdersSalvaInTabella>>
>;
export type GetPlaceholdersSalvaInTabellaQueryError = ErrorType<WsProblema>;

/**
 * @summary Lista placeholder
 */
export const useGetPlaceholdersSalvaInTabella = <
  TData = Awaited<ReturnType<typeof getPlaceholdersSalvaInTabella>>,
  TError = ErrorType<WsProblema>,
>(
  params: GetPlaceholdersSalvaInTabellaParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPlaceholdersSalvaInTabella>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetPlaceholdersSalvaInTabellaQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};
